<mat-form-field
  [appearance]="isInTableHeader ? 'standard' : 'outline'"
  [ngClass]="{ 'w-100': isFullWidth }"
>
  @if (label) {
    <mat-label
      >{{ label }}
      @if (isMultiple && model && model.length) {
        <span>({{ model.length }})</span>
      }
    </mat-label>
  }
  <mat-select
    name="select"
    [(ngModel)]="model"
    [required]="isRequired"
    [multiple]="isMultiple"
    [disabled]="isDisabled || !list.length"
    [placeholder]="labelPrefix + label"
    (openedChange)="searchText = ''"
    (ngModelChange)="onModelChange()"
    panelClass="cim-select"
  >
    <input
      placeholder="Search"
      matInput
      [(ngModel)]="searchText"
      class="select-input-search"
    />
    @if (needAllOption) {
      <mat-option>All {{ label }}</mat-option>
    }
    @for (item of list | search: searchText; track $index) {
      <mat-option
        [hidden]="item.hidden == true"
        [value]="item"
        [disabled]="item.divider"
        >{{ item.name }}</mat-option
      >
    }
  </mat-select>
</mat-form-field>
